define([
    "../../hereMapsModule",
    "text!./trackingHereMaps.html",
    "text!./trackingDetailsPopupTemplate.html"
], function (hereMapsModule, trackingTemplate, hereMarkersPopupTemplate) {
    "use strict";

    return hereMapsModule.directive("trackingHereMaps", [
        "markerImage", "hereMapsService", "hereMapsMarkersFactory",
        function (markerImage, hereMapsService, hereMapsMarkersFactory) {
            return {
                restrict: "E",
                template: trackingTemplate,
                scope: {
                    clusterMarkersPoints: "=?",
                    onRegisterApi: "=",
                    onRefreshCallback: "&?"
                },
                controller: ["$scope", "$timeout", "$compile", "$interval",
                    function ($scope, $timeout, $compile, $interval) {
                    $scope.state = {
                        showMonitorableTable: false,
                        isRefreshing: false,
                        isLabelsCardOpen: false
                    };

                    var markersHereApi = null;
                    var refreshInterval = null;
                    $scope.clusterMarkersToAdd = [];
                    $scope.labels = markerImage.labels();

                    function doShowMonitorableTable() {
                        $scope.state.showMonitorableTable = !$scope.state.showMonitorableTable;
                        $timeout(function () {
                            var map = hereMapsService.getMap();
                            map.getViewPort().resize();
                        });
                    }

                    function tapClusterAction(tapClusterContext) {
                        var markers = tapClusterContext.markers;
                        var target = tapClusterContext.event.target;
                        var clusterPosition = target.getGeometry();

                        var ui = hereMapsService.getUi();
                        var Here = hereMapsService.getHere();
                        var map = hereMapsService.getMap();

                        if ($scope.currentBubble) {
                            ui.removeBubble($scope.currentBubble);
                        }

                        var popupScope = $scope.$new(true);
                        popupScope.parameters = markers.map(function (marker) {
                            var markerData = marker.getData();
                            return markerData.popupConfig.templateParameter;
                        });

                        var bubbleCoords = clusterPosition;

                        var compiledContent = $compile(hereMarkersPopupTemplate)(popupScope);

                        $timeout(function() {
                            $scope.currentBubble = new Here.ui.InfoBubble(bubbleCoords, {
                                content: compiledContent[0]
                            });

                            ui.addBubble($scope.currentBubble);

                            if (map) {
                                map.setCenter(bubbleCoords);

                                //tenta manter o popup mais centralizado
                                var screenPosition = map.geoToScreen(bubbleCoords);
                                if (screenPosition) {
                                    screenPosition.y -= 70;
                                    var newCenter = map.screenToGeo(screenPosition.x, screenPosition.y);

                                    map.setCenter(newCenter);
                                }
                            }

                            $scope.currentBubble.addEventListener("statechange", function(e) {
                                if (e.target.getState() === "closed") {
                                    popupScope.$destroy();
                                    $scope.currentBubble = null;
                                }
                            });
                        }, 50);
                    }

                    $scope.centerMapOnMarker = function (marker) {
                        var coordinate = {
                            lat: marker.geographicInfo.latitude,
                            lng: marker.geographicInfo.longitude
                        };
                        markersHereApi.focusOnMarkerByCoordinate(coordinate);
                    };

                    $scope.openLabelsCard = function() {
                        $scope.state.isLabelsCardOpen = !$scope.state.isLabelsCardOpen;
                    };

                    $scope.onRegisterHereApi = function (api) {
                        markersHereApi = api;
                        markersHereApi.setClusterTapAction(tapClusterAction);
                        if ($scope.onRegisterApi) {
                            $scope.onRegisterApi({
                                hereMaps: markersHereApi,
                                tracking: {
                                    state: $scope.state,
                                    actions: $scope.actions
                                }
                            });
                        }

                        if ($scope.clusterMarkersToAdd && $scope.clusterMarkersToAdd.length > 0) {
                            setClusterMarkers($scope.clusterMarkersToAdd);
                            $scope.clusterMarkersToAdd = [];
                        }
                    };

                    $scope.here = {
                        maps: {
                            hasFullScreen: true,
                            hasAutomaticRefresh: true,
                            possibleButtons: {
                                hasMonitorableTable: true,
                                hasLabelsCard: true,
                                hasFocusOnMarkers: true
                            },
                            actions: {
                                doShowMonitorableTable: doShowMonitorableTable,
                                openLabelsCard: $scope.openLabelsCard,
                            },
                            automaticRefresh: {
                                isRefreshing: false,
                                action: toggleAutomaticRefresh
                            },
                            conditionalHeight: {
                                height: "auto",
                                active: true
                            }
                        },
                        markersData: {
                            clusterMarkersPoints: [],
                            draggable: false,
                            onRegisterApi: $scope.onRegisterHereApi
                        }
                    };

                    $scope.$watchCollection("clusterMarkersPoints", setClusterMarkersPoints);

                    function setClusterMarkersPoints(clusterMarkers) {
                        if (!markersHereApi || !hereMapsMarkersFactory) {
                            $scope.clusterMarkersToAdd = clusterMarkers;
                            return;
                        }
                        setClusterMarkers(clusterMarkers);
                    }

                    function setClusterMarkers(clusterMarkers) {
                        markersHereApi.clearClusterMarkersLayer();

                        if (!clusterMarkers || clusterMarkers.length === 0) {
                            $scope.here.markersData.clusterMarkersPoints = [];
                            return;
                        }

                        $scope.here.markersData.clusterMarkersPoints = clusterMarkers;
                        var clusterLayerData = hereMapsMarkersFactory.createClusterMarkersLayer(
                            $scope.here.markersData
                        );
                        markersHereApi.setClusterMarkersLayer(clusterLayerData.layer, clusterLayerData.provider);

                        markersHereApi.centerMapOnMarkersWithPadding(100);
                    }

                    function toggleAutomaticRefresh(){
                        $scope.here.maps.automaticRefresh.isRefreshing = !$scope.here.maps.automaticRefresh.isRefreshing;
                        if ( $scope.onRefreshCallback && $scope.here.maps.automaticRefresh.isRefreshing ) {
                            refreshInterval = $interval(function () {
                                $scope.onRefreshCallback();
                            }, 30000);
                        }
                        else {
                            $interval.cancel(refreshInterval);
                        }
                    }

                    $scope.$on("$destroy", function() {
                        if (refreshInterval) {
                            $interval.cancel(refreshInterval);
                        }
                    });
                }]
            };
        }]);
});